export default __webpack_public_path__ + "static/media/Expert-Profile.6cabb46d.svg";